export enum ErrorName {
  Default = 'Error',
  Network = 'NetworkError',
}

export type ErrorOptions = {
  cause?: Error;
  description?: string;
  /**
   * Human-readable body for the error detail template — rendered as-is, so it
   * must stay a string (see `StackTemplates.tsx`).
   */
  body?: string;
  /**
   * The parsed error response body, kept as received. Use this to branch on
   * machine-readable fields such as the backend's numeric `code`; use
   * {@link getErrorCode} instead of reaching into it directly.
   */
  payload?: unknown;
};

export const DEFAULT_ERROR_DESCRIPTION =
  'Versuchen Sie es später erneut oder wenden Sie sich an unseren Support.';
